import { FieldDescription, FieldError } from "../components/ui/field"

type Props = {
  description?: string
  error?: string | null
}

export default function FieldDescriptionOrError({ description, error }: Props) {
  if (error) {
    return <FieldError>{error}</FieldError>
  }

  if (description) {
    return <FieldDescription>{description}</FieldDescription>
  }

  return null
}
